
  export default {
    name: 'CustomTooltip',
    props: {
      text: {
        type: String,
        default: null
      },
      withIcon: {
        type: Boolean,
        default: true
      }
    }
  }
